const dermoscopy =[

    {label:"Site of lesion",
    controlType:"text",
    options:[]
    },

    {label: "Dermoscopy Features:",
    controlType: "checkbox group extra wide",
    options: ["Atypical network", "Peripheral lines", "Pseudopods", "Soft white lines","Irreg. brown /black dots or clods", "Grey-blue structures", "Structureless areas", "Atypical vascular pattern", "Multicomponent"]
    },

    {label: "Any Other Dermoscopy Features",
    controlType: "text area",
    options: []
    },

    { label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
]

export default dermoscopy